import { PaymentType } from '@/features/orders/constants/app'
import { useFormDeliveryTypeCategoryValue } from '@/features/pos/components/OrderFinalization/form'
import { DeliveryPaymentMapping } from '@/features/pos/components/OrderFinalization/types'
import { sortPaymentTypesVisualOrder } from '@/features/pos/components/OrderFinalization/utils/sortPaymentTypesVisualOrder'
import { useMemo } from 'react'

const posPaymentMethods: PaymentType[] = [
    PaymentType.Cash,
    PaymentType.CardOnsite,
    PaymentType.MealVoucher,
    PaymentType.MealVoucherCard,
] as const

export const usePaymentTypes = (
    deliveryPaymentMappings: DeliveryPaymentMapping[]
): PaymentType[] => {
    const deliveryTypeCategory = useFormDeliveryTypeCategoryValue()

    return useMemo(() => {
        return sortPaymentTypesVisualOrder(
            deliveryPaymentMappings
                .find(
                    (deliveryPaymentMapping) =>
                        deliveryPaymentMapping.deliveryTypeCategory === deliveryTypeCategory
                )
                ?.paymentTypes.filter((paymentType) => posPaymentMethods.includes(paymentType)) ??
                []
        )
    }, [deliveryPaymentMappings, deliveryTypeCategory])
}
